"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    upload_drag_here_unisex: 'להעלאה יש לגרור את הקבוץ שרוצים להעלות',
    upload_drag_here_male: 'גרור לכאן את הקובץ שברצונך להעלות',
    upload_drag_here_female: 'גררי לכאן את הקובץ שברצונך להעלות',
    upload_choose_file_unisex: 'לבחור קובץ',
    upload_choose_file_male: 'בחר קובץ',
    upload_choose_file_female: 'בחרי קובץ',
    upload_file: 'העלאת קובץ',
    or: 'או',
    uploader_size_limits: 'קובץ עד',
    uploader_type_limits: 'מסוג',
    uploader_type_error: 'לא ניתן להעלות קובץ מסוג זה',
    uploader_size_error: 'גודל הקובץ חורג מהגודל המותר'
  },
  ar: {
    upload_drag_here_unisex: 'لرفع ملفّ يجب جرّ الملفّ المُراد رفعه',
    upload_drag_here_male: 'جرّ إلى هنا الملفّ الذي تريد رفعه',
    upload_drag_here_female: 'جرّي إلى هنا الملفّ الذي تريدين رفعه',
    upload_choose_file_unisex: 'لاختيار ملفّ',
    upload_choose_file_male: 'اختَر ملفًّا',
    upload_choose_file_female: 'اختاري ملفًّا',
    upload_file: 'رفع الملف',
    or: 'او',
    uploader_size_limits: 'ملفّ حتّى',
    uploader_type_limits: 'من نوع',
    uploader_type_error: 'لا يمكن رفع ملفّ من هذا النوع',
    uploader_size_error: 'حجم الملفّ يتجاوز الحجم المسموح به'
  },
  en: {
    upload_drag_here_unisex: "Drag the file you'd like upload",
    upload_drag_here_male: "Drag the file you'd like upload",
    upload_drag_here_female: "Drag the file you'd like upload",
    upload_choose_file_unisex: 'Choose a file',
    upload_choose_file_male: 'Choose a file',
    upload_choose_file_female: 'Choose a file',
    upload_file: 'Upload file',
    or: 'or',
    uploader_size_limits: 'max file size',
    uploader_type_limits: 'of type/s',
    uploader_type_error: 'Select file type is incompatible',
    uploader_size_error: 'Select file size is to large'
  }
};
exports.labels = labels;